<div *ngIf="loading" class="text-center pt-5">
	<app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="!loading" id="folder-list" class="mb-2 pt-2">
	<div class="row justify-content-beetwen g-2">
		<div class="col">
			<h3 class="mb-0">{{ editMode ? 'Edit' : 'Create'}} Questionnaire</h3>
		</div>
		<div class="col-auto">
			<div class="d-flex gap-2 align-items-start">
				<button [routerLink]="['/projects', project_id]" [queryParams]="{ tab: 'questionnaires' }" class="btn btn-danger w-sm create-folder-modal flex-shrink-0" [disabled]="submitted && spinner">Cancel</button>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!loading" class="card" style="box-shadow: none">
	<div class="card-header border-0">
		<div class="progress progress-step-arrow progress-info">
			<div class="progress-bar w-100" *ngFor="let step of steps; let i = index" [ngClass]="i === currentStep+1 ? 'next' : i > currentStep+1 ? 'bg-light text-body after' : ''">
				<span>
					{{ step }}
					<i *ngIf="i === 1 && chapters.length === 0 && chaptersError && status.name === 'ACTIVE'" ngbTooltip="You must have at least one chapter!" container="body" class="text-warning ri-error-warning-fill align-middle ms-2"></i>
				</span>
			</div>
		</div>
	</div>
	<div [ngSwitch]="currentStep" class="card-body h-100 pt-0 border-0">
		<ngx-simplebar class="px-3 file-manager-content-scroll">
			<div *ngSwitchCase="0">
				<form>
					<div class="mb-3">
						<div class="row">
							<div class="col-lg-4 col-12">
								<label for="name" class="form-label">Questionnaire name <span class="text-danger">*</span></label>
								<input type="text" class="form-control" id="name" placeholder="Enter questionnaire name" required [(ngModel)]="questionnaire_name" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !questionnaire_name }">
								<div class="invalid-feedback"> Please enter questionnaire name </div>
							</div>
							<div class="col-lg-4 col-12">
								<label for="lang" class="form-label">Questionnaire Language <span class="text-danger">*</span></label>
								<ng-select id="lang" [items]="listLang" bindLabel="name" bindValue="lang" [clearable]="false" placeholder="Select a language" (change)="onLanguageChange()" [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
									<ng-template ng-label-tmp let-item="item">
										<img height="15" width="15" [src]="item.flag" alt="item.text" />
										<span class="ms-2">{{ item.text }}</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item" let-index="index">
										<img height="15" width="15" [src]="item.flag" alt="item.text" />
										<span class="ms-2">{{ item.text }}</span>
									</ng-template>
								</ng-select>
							</div>
							<div class="col-lg-4 col-12">
								<label for="questionnaire_status" class="form-label">Questionnaire Status <span class="text-danger">*</span></label>
								<ng-select id="questionnaire_status" [items]="listStatus" [clearable]="false" placeholder="Select a status" [(ngModel)]="status" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && !status }" required>
									<ng-template ng-label-tmp let-item="item">
										<span>{{ item.name | titlecase  }}</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item" let-index="index">
										<span>{{ item.name | titlecase }}</span>
									</ng-template>
								</ng-select>
								<div class="invalid-feedback"> Please select status </div>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<div class="row">
							<div class="col-lg-6 col-12">
								<label for="q_baseline" class="form-label">Questionnaire Baseline <span class="text-danger">*</span></label>
								<ng-select [loading]="questionnaireBaslineLoading" id="q_baseline" [items]="baselines" bindLabel="name" [disabled]="questionnaire_id !== null" placeholder="Select baseline" [ngClass]="{ 'is-invalid': submitted && !selectedBaseline }" [(ngModel)]="selectedBaseline" [ngModelOptions]="{standalone: true}">
									<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
										<div class="card m-0">
											<div class="card-body">
												<h5 class="card-title mb-2">{{ item.name }}</h5>
												<div class="card-text text-muted" style="white-space: pre-line;">
													<div class="ql-container ql-snow" style="border-width: 0;">
														<div class="ql-editor" [innerHTML]="item.description"></div>
													</div>
												</div>
											</div>
										</div>
									</ng-template>
									<ng-template ng-loadingspinner-tmp>
										<div class="lds-ellipsis">
												<div></div>
												<div></div>
												<div></div>
												<div></div>
										</div>
									</ng-template>
								</ng-select>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label for="description" class="form-label">Description</label>
						<quill-editor id="description" [placeholder]="'Insert questionnaire description here...'" [styles]="{ height: '250px' }" [(ngModel)]="description" [ngModelOptions]="{standalone: true}" class="d-block"></quill-editor>
					</div>
				</form>	
			</div>
			<div *ngSwitchCase="1">
				<app-questionnaire-chapters [chapters]="chapters" (chaptersRemoved)="onChaptersRemoved($event)" (questionsRemoved)="onQuestionRemoved($event)"></app-questionnaire-chapters>
			</div>
			<div *ngSwitchCase="2">
				<div class="card">
					<div class="row">
						<div class="col-lg-12">
							<div class="card-body border-bottom border-bottom-dashed">
								<div class="row g-3">
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Questionnaire Name</p>
										<h5 class="fs-15 mb-0">{{ questionnaire_name }}</h5>
									</div>
									<div class="col-lg-3 col-6">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Date</p>
										<h5 class="fs-15 mb-0">{{ today | date:'MMM d, y, h:mm a' }}</h5>
									</div>
									<div class="col-lg-2 col-4">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Status</p>
										<span class="badge bg-{{ status.status_color }}-subtle text-{{ status.status_color }} fs-11">{{ status.name }}</span>
									</div>
									<div class="col-lg-2 col-4 text-center">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Total Chapters</p>
										<h5 class="fs-15 mb-0">{{ chapters.length }}</h5>
									</div>
									<div class="col-lg-2 col-4 text-center">
										<p class="text-muted mb-2 text-uppercase fw-semibold">Total Quesions</p>
										<h5 class="fs-15 mb-0">{{ questionLength }}</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="card-body">
								<app-questionnaire-chapters [viewMode]="true" [chapters]="chapters"></app-questionnaire-chapters>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ngx-simplebar>
		<div class="row mt-2">
			<div *ngIf="currentStep > 0" class="me-auto col">
				<button (click)="backStep()" class="btn btn-primary btn-load" [disabled]="submitted && spinner">Back</button>
			</div>
			<div class="text-end col">
				<button (click)="currentStep < steps.length-1 ? nextStep() : saveQuestionnaire()" class="btn btn-primary btn-load" [disabled]="submitted && spinner">
					<span class="d-flex justify-question-center">
						<span class="spinner-border" role="status" *ngIf="submitted && spinner">
							<span class="visually-hidden">Loading...</span>
						</span>
						<span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ currentStep < steps.length-1 ? 'Next' :  editMode ? 'update' : 'Create' }} </span>
					</span>
				</button>
			</div>
		</div>
	</div>
</div>


<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
				<lord-icon *ngIf="success" src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
				<lord-icon *ngIf="!success" src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
				<p *ngIf="!success" class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>